import React, { useState } from "react";

const Login = ({ setLoggedIn, setIsLoading }) => {
  const [mobileNumber, setMobileNumber] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const handleLogin = (e) => {
    e.preventDefault();
    if (mobileNumber.length === 10) {
      setIsLoading(true);  // Set loading in parent component
      
     
      setTimeout(() => {
        setLoggedIn(true);
        setIsLoading(false);  
      }, 1500);
    } else {
      setError("Please enter a valid 10-digit mobile number.");
    }
  };

  return (
<div className="flex flex-col justify-center items-center min-h-screen p-4 bg-gray-100">
  {/* Logo outside and above the card */}
  <div className="mb-6">
    <img 
      src="https://www.restroworks.com/wp-content/uploads/2023/09/restroworks-logo.png" 
      alt="RetroWorks" 
      className="h-20" 
    />
  </div>
  
  <div className="mb-8 text-center">
    <h1 className="text-3xl md:text-4xl font-bold text-blue-700 mb-2">Hello!</h1>
    <h2 className="text-2xl md:text-3xl font-semibold text-gray-800 relative">
      View your digital bills
      <span className="block h-1 w-24 bg-blue-500 mx-auto mt-3 rounded-full"></span>
    </h2>
  </div>
  
  {/* Card */}
  {/* <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md">
    <form onSubmit={handleLogin}>
      <div className="mb-4">
        <label htmlFor="mobile" className="block text-sm font-medium text-gray-700 mb-1">
          Mobile Number
        </label>
        <input
          type="tel"
          id="mobile"
          className="w-full p-3 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
          placeholder="Enter your mobile number"
          value={mobileNumber}
          onChange={(e) => setMobileNumber(e.target.value)}
          required
        />
      </div>
      {error && <p className="text-red-500 text-sm mb-4">{error}</p>}
      <button
        type="submit"
        className="w-full bg-blue-600 text-white py-3 px-4 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
      >
        Submit
      </button>
    </form>
  </div> */}
</div>
  );
};

export default Login;
